import Component from '../abstracts/Component';
import NewsletterLogic from '../businessLogic/NewsletterLogic';
import Cookies from 'js-cookie';
import FidelityPopupComponent from './FidelityPopupComponent';

export default class NewsletterComponent extends Component {
  get SELECTORS() {
    return {
      newsletterPopup: '[data-modal-class="modal-newsletter"]',
    };
  }

  constructor() {
    super();
    this.newsletterPopup;
  }

  initProperties() {
    this.link = document.body.dataset.nlLink ? document.body.dataset.nlLink : '/modals/newsletter';
  }

  initModal() {
    return $.ajax({
      url: `${this.link}?xhr=true`,
      dataType: 'html'
    });
  }

  bindEvents() {
    let self = this;

    this.$on(this.$customEvents.FIDELITY_POPUP.hide, () => {
      if(self.newsletterPopup && !self.getCookie()) {
        self.newsletterPopup.classList.add('show');
      }
    });
  }

  insertNewsletterModal(response) {
    let self = this;
    let html = new DOMParser().parseFromString(response, 'text/html');
    const fidelityPopup = new FidelityPopupComponent();
    // popup insertion
    document.body.appendChild(html.querySelector('section'));
    // show popup
    this.newsletterPopup = document.querySelector(this.SELECTORS.newsletterPopup);
    if(this.newsletterPopup && (!fidelityPopup.isShown() || fidelityPopup.getCookie())) {
      this.newsletterPopup.classList.add('show');
    }
    // hide popup
    this.newsletterPopup.querySelector('.vex-close').addEventListener('click', (e) => {
      self.newsletterPopup.classList.remove('show');
      self.setCookie();
    });
  }

  checkNewsletterModal() {
    let self = this;
    let insertModal = !this.getCookie() &&
      !document.body.classList.contains('editmode') &&
      document.body.dataset.store !== 'maxmarawww';

    if(insertModal) {
      if(Cookies.get('cookies-disclaimer-v1')) {
        this.initModal().then(html => {
          console.log('[Newsletter] modal:open');
          self.insertNewsletterModal(html);
        });
      } else {
        this.$on(this.$customEvents.COOKIE.accepted, ({event}) => {
          self.initModal().then(html => {
            console.log('[Newsletter] modal:open');
            self.insertNewsletterModal(html);
          });
        });
      }
    }
  }

  render() {
    this.log('Rendering...');
    if(!this.getCookie()) {
      this.initProperties();
      this.NewsletterLogic = new NewsletterLogic(this);
      this.NewsletterLogic.render();
      this.bindEvents();
      this.checkNewsletterModal();
    }
  }

  get COOKIE_NAME() {
    const modalkey = document.body.dataset.nlKey || 'default_modal';
    return 'nl_' + modalkey + '_hide';
  }

  setCookie() {
    Cookies.set(this.COOKIE_NAME, 'true', {
      expires: 365,
      path: '/'
    });
  }

  getCookie() {
    return Cookies.get(this.COOKIE_NAME);
  }
}